document.addEventListener('DOMContentLoaded', () => {
    // Opciones personalizadas
    const rectSelector = '.rect-selector';

    const customOptionsThumbs = {
        spaceBetween: 16,
        pagination: false,
        scrollbar: false,
        navigation: false,
        slidesPerView: 2,
    }
    let swiperInstalatinsThumbs = null;
    let swiperInstanceMain = null;
    try {
        // Crear una instancia de SwiperClass con el selector y las opciones
        swiperInstalatinsThumbs = new SwiperClass(
            '.thumb-swiper-instalations',
            customOptionsThumbs
        )
        
        
    } catch (error) { }
    
    function coordenates() {
        let oneSlider = document.querySelectorAll('.thumb-swiper-instalations .swiper-slide')
        rectCero = oneSlider[0].firstElementChild.getBoundingClientRect();
        rectOne = oneSlider[1].firstElementChild.getBoundingClientRect();
        rectBlue = document.querySelector(rectSelector).getBoundingClientRect();
        // console.log(oneSlider[0].firstElementChild);
        let coordenates = {
            cero: rectCero.x + (rectCero.width / 2) - (rectBlue.width/2),
            one: rectOne.x + (rectOne.width / 2) - (rectBlue.width/2),
        }
        if (isMobile()) {
            coordenates = {
                cero: rectCero.x + (rectCero.width / 10),
                one: rectOne.x + (rectOne.width / 10),
            }
        }
        return coordenates;
    }

    if (swiperInstalatinsThumbs !== null) {
        
        const customOptions = {
            spaceBetween: 16,
            pagination: false,
            navigation: false,
            scrollbar: false,
            autoHeight: true,
            thumbs: {
                swiper: swiperInstalatinsThumbs.swiper
            },
            on: {
                init: function(){
                    anime.set(rectSelector, {
                        translateX: coordenates().cero,
                    })
                },
            }
        }
        // console.log(swiperInstalatinsThumbs.swiper);
        const instalationsSwiper = new SwiperClass('.swiper-instalations', customOptions);
        swiperInstanceMain = instalationsSwiper.swiper;
        swiperInstanceMain.on('slideChange', () => {
            if (swiperInstanceMain.activeIndex === 0) {
                anime({
                    targets: rectSelector,
                    translateX: coordenates().cero,
                })
            }
            else {
                anime({
                    targets: rectSelector,
                    translateX: coordenates().one,

                })
            }
        })
    }

    window.addEventListener('resize', () => {
        if (swiperInstanceMain) {

            try {
                if (swiperInstanceMain.activeIndex === 0) {
                    anime.set(rectSelector, {
                        translateX: coordenates().cero,
                    })
                }
                else {
                    anime.set(rectSelector, {
                        translateX: coordenates().one,
                    })
                }
            } catch (error) {
                
            }
        }
    });

    console.log('instalation loaded')
})
